import { Component, OnInit } from '@angular/core';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-disburse-member-card',
  templateUrl: './disburse-member-card.component.html',
  styleUrls: ['./disburse-member-card.component.scss']
})
export class DisburseMemberCardComponent implements OnInit {
  success: boolean;
  templateUrl: any;
  baseUrl;

  constructor(
    private router: Router,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
  ) { }

  ngOnInit(): void {

    let tenantId = localStorage.getItem("tenantId") ?? 1;
    let parkId = localStorage.getItem("parkId") ?? 1;
    this.baseUrl = `${environment.apiBaseUrl}api/Company/GetMemberCardListByTenantId?parkId=${parkId}`;

    this.activatedRoute.queryParams.subscribe((res) => {
      this.success = res?.sucess ? res?.sucess : false;
    });
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        // this.prepareTableData(JSON.parse(data));
        this.dataService.setExcelData(data);
        this.router.navigateByUrl('disburse-member-card-preview');
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });
  }
}
